import React from "react";
import FetchingDataScreen from "../components/fetchingDataScreen";
import DefaultSkeleton from "../components/skeletons/defaultSkeleton";
import { CustomPreLoader } from "../Apps/startLoader/preLoader";

export const getDataLoadingScreen = (screenStyle, loaderMessage) => {

    switch (screenStyle) {
        case 'CUSTOM_PRE_LOADER':
            return <CustomPreLoader />;
        case 'FETCHING_LOADER':
            return <FetchingDataScreen loaderMessage={loaderMessage} />;
        default:
            return <DefaultSkeleton />;
    }
};